<template>
  <div class="wlx-site-manager-wrapper">
    <el-tabs tab-position="top" style="height: auto" v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="站点管理" name="first">
        <SiteManagement v-if="tabName=='first'"></SiteManagement>
      </el-tab-pane>
      <el-tab-pane label="站点申请" name="second">
        <SiteAuthentication v-if="tabName=='second'"></SiteAuthentication>
      </el-tab-pane>
      <el-tab-pane label="站点活动" name="third">
        <SiteActivity v-if="tabName=='third'"></SiteActivity>
      </el-tab-pane>
      <el-tab-pane label="申请标准" name="fourth">
        <certifyStadard v-if="tabName=='fourth'" type="3"></certifyStadard>
      </el-tab-pane>
      <el-tab-pane label="认证节点" name="fifth">
        <AuthenticationNode v-if="tabName=='fifth'" type="3"></AuthenticationNode>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { MU_UPATE_AUTH } from "store/index";
import SiteManagement from "page/xSchool/manager/SiteManagement.vue";
import SiteAuthentication from "page/xSchool/manager/SiteAuthentication.vue";
import SiteActivity from "page/xSchool/manager/SiteActivity.vue";
import certifyStadard from "page/xSchool/manager/siteCertifyStadard.vue";
import AuthenticationNode from "page/xSchool/manager/siteAuthenticationNode.vue";
export default {
  data() {
    return {
      tabName: "first"
    };
  },
  components: {
    SiteManagement,
    SiteAuthentication,
    SiteActivity,
    certifyStadard,
    AuthenticationNode
  },
  created() {
    
    // var that = this;
    // if (localStorage["userId"] !== undefined) {
    //   that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    // }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  computed: {}
};
</script>

<style lang="scss">

</style>
